import { useEffect, useState } from 'react';
import { EcosystemActivityPane } from '../panes/ecosystem-activity-pane';
import { EcosystemOverviewPane } from '../panes/ecosystem-overview-pane';
import { EcosystemRolePane } from '../panes/ecosystem-role-pane';
import { GeographicOverviewPane } from '../panes/geographic-overview-pane';
import { OrganizationDetailPane } from '../panes/organization-detail-pane';
import { OrganizationPane } from '../panes/organization-pane';
import { OrganizationSearchPane } from '../panes/organization-search-pane';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import { useHover, useHoverDispatch } from '../../contexts/hover-context';
import { useNavigation } from '../../contexts/navigation-context';

export const AppSidePanel = ({ selectedIssue, ecosystemPhases, ecosystemRoles, ecosystemActivities, organizations }) => {
  const { activityIds: selectedActivityIds, roleIds: selectedRoleIds } = useFilter();
  const dispatchFilter = useFilterDispatch();

  const { currentPage } = useNavigation();

  useEffect(() => {}, [currentPage, selectedRoleIds, selectedActivityIds]);

  const isPaneVisible = (paneId) => {
    switch (currentPage.pageId) {
      case 'ecosystem-overview': {
        switch (paneId) {
          case 'ecosystem-overview-pane': {
            return true;
          }
          case 'ecosystem-role-pane': {
            return selectedActivityIds.length > 0 || selectedRoleIds.length > 0;
          }
          case 'ecosystem-activity-pane': {
            return selectedActivityIds.length > 0;
          }
          default: {
            return false;
          }
        }
      }
      case 'geographic-overview': {
        switch (paneId) {
          case 'geographic-overview-pane': {
            return true;
          }
          default: {
            return false;
          }
        }
      }
      case 'organization-search': {
        switch (paneId) {
          case 'organization-search-pane': {
            return true;
          }
          default: {
            return false;
          }
        }
      }
      case 'organization-detail': {
        switch (paneId) {
          case 'organization-detail-pane': {
            return true;
          }
          default: {
            return false;
          }
        }
      }
      case 'organization-compare': {
        return false;
      }
      default: {
        return false;
      }
    }
  };

  if (!currentPage?.pageId) {
    return;
  }

  return (
    <div className="pane-content-container">
      <EcosystemOverviewPane
        key={'ecosystem-overview-pane'}
        ecosystemRoles={ecosystemRoles}
        ecosystemActivities={ecosystemActivities}
        visible={isPaneVisible('ecosystem-overview-pane')}
        issue={selectedIssue}
      />
      <GeographicOverviewPane key={'geographic-overview-pane'} ecosystemPhases={ecosystemPhases} visible={isPaneVisible('geographic-overview-pane')} />
      <OrganizationSearchPane
        key={'organization-search-pane'}
        ecosystemPhases={ecosystemPhases}
        activities={ecosystemActivities}
        visible={isPaneVisible('organization-search-pane')}
      />
      <OrganizationDetailPane
        key={'organization-detail-pane'}
        ecosystemPhases={ecosystemPhases}
        ecosystemActivities={ecosystemActivities}
        visible={isPaneVisible('organization-detail-pane')}
      />
      <EcosystemRolePane
        key={'ecosystem-role-pane'}
        ecosystemRoles={ecosystemRoles}
        ecosystemActivities={ecosystemActivities}
        visible={isPaneVisible('ecosystem-role-pane')}
      />
      <EcosystemActivityPane key={'ecosystem-activity-pane'} ecosystemActivities={ecosystemActivities} visible={isPaneVisible('ecosystem-activity-pane')} />
    </div>
  );
};
